import {FC, useContext} from 'react'
import {ToggleHelpDrawer} from './help-drawer/ToggleHelpDrawer'
import {HelpDrawer} from './help-drawer/HelpDrawer'
import {PurchaseButton} from './purchase/PurchaseButton'
import './footer.scss'
import { KTIcon } from '../../helpers/components/KTIcon'
import { ButtonState, ToolbarContext } from '../../layout/components/toolbar/Toolbar'
import { faComments } from '@fortawesome/free-solid-svg-icons'
import { useHideOnScroll } from '../../../app/modules/widgets/hooks/useHideOnScroll'
import './toolbar.css'

const renderButton = (button: ButtonState) => {
  if (!button.enabled || !button.text) return null;

  return (
    <a href="#" className="btn btn-sm btn-flex btn-light fw-bold" onClick={button.action}>
      <KTIcon iconName={button.icon||""} className="fs-6 text-muted me-1" />
      {button.text}
    </a>
  );
};

// Friendly rounded-head bot, standing in for the generic FontAwesome robot icon.
// Eyes get a soft, offset glow animation (see .robot-eye in toolbar.css) so the
// launcher reads as "alive" rather than a static icon.
const AiChatIcon: FC = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="12" y1="2.6" x2="12" y2="5.4" stroke="#AEB6C2" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="12" cy="2.2" r="1.15" fill="#AEB6C2" />
    <path
      d="M5 10.5c0-1.9 1-3.4 2.4-4.2a1.6 1.6 0 0 1 1.4-2.3h6.4a1.6 1.6 0 0 1 1.4 2.3C18 7.1 19 8.6 19 10.5v5A4.5 4.5 0 0 1 14.5 20h-5A4.5 4.5 0 0 1 5 15.5v-5Z"
      fill="#C6CCD6"
    />
    <circle cx="4.4" cy="12.5" r="1.4" fill="#C6CCD6" />
    <circle cx="19.6" cy="12.5" r="1.4" fill="#C6CCD6" />
    <rect x="7" y="9.5" width="10" height="6" rx="3" fill="#15171C" />
    <circle className="robot-eye robot-eye-left" cx="10" cy="12.5" r="1.15" fill="#5EE6C8" />
    <circle className="robot-eye robot-eye-right" cx="14" cy="12.5" r="1.15" fill="#5EE6C8" />
  </svg>
);

const RightToolbar: FC = () => {
  const { toolbarState } = useContext(ToolbarContext);
  const isVisible = useHideOnScroll(toolbarState.alwaysDisplay);

  if (!isVisible) {
    return null;
  }

  return (
    <>
      <div className="d-flex position-fixed px-5 fw-bolder z-index-2 mb-12 me-10 bottom-0 end-0 gap-2">
        {toolbarState.showAIChat &&
          <button
          className='buttonStyle'
          id='kt_drawer_chat_toggle'>
          <AiChatIcon />
          </button>
        }
        {toolbarState.showRightToolbar && <>
          {renderButton(toolbarState.primaryButton)}
        {renderButton(toolbarState.secondaryButton)}
        {renderButton(toolbarState.tertiaryButton)}
        </>}
        
      </div>
      <HelpDrawer />
    </>
  );
};

export {RightToolbar}
